import * as _ from 'lodash-es'
import { useState } from 'react'
import { useRouter } from 'next/router'
import { useQueryNext } from '../../../../componentsF/hooksF/useQueryNextF.js'
import { Box } from '@chakra-ui/react'
import { old_game_stack_pathname } from '../../common/urlsF.mts'
import Link from 'next/link'
import { CanvasGameDraw } from '../../CanvasGameDrawF.jsx'
import { Image } from '@chakra-ui/react'
import { Ptext } from '../../../../componentsF/Chakra3F/ChakraF.jsx'
import { gql } from '@apollo/client'
import { WrapRewindGame } from './WrapRewindGameF.jsx'
import { ErrLoadingWrap } from '../../../../componentsF/ErrLoadingF.jsx'
import { GamePgCont } from '../../common/GenericGamePage.jsx'

import { GameCtxWrap } from '../../GameCompsF.jsx'
import { showAiCost } from '../../../sharedF/constantsF.mts'
export const GetOldGameStateQuery = gql`query (
  $ppOldGameId: ID, $gameRoom: String, $lastCursorHash: String,
) {
  gqGame(ppOldGameId: $ppOldGameId, gameRoom: $gameRoom, lastCursorHash: $lastCursorHash) {
    gqGameState
    gqActionsHistA
    applyToIdx
  }
}`

const PromptCard = ({playerAlias, lastDescription, paper_stack_name, my}) => {
  const {query: {ppOldGameId, gameRoom}} = useRouter()
  const query = {ppOldGameId, paper_stack_name, gameRoom}
  const href = {pathname: old_game_stack_pathname, query}

  return <Link {...{href}}><Box {...{my, p: 2, bg: 'blue.800', rounded: 'full'}}>
    <Ptext {...{fontSize: '3xl'}}>
      {playerAlias + "'s idea:"}
    </Ptext>
    <Ptext {...{fontSize: '2xl'}}>
      {lastDescription}
    </Ptext>
  </Box></Link>
}

const AiCostLabel = ({aiCostUsd}) => {
  if (!showAiCost || !aiCostUsd) return null
  const costCents = (aiCostUsd * 100).toFixed(3)
  return <Ptext {...{as: 'span', fontSize: 'sm', color: 'gray.400', float: 'right'}}>{costCents}c</Ptext>
}

const DescriptionCard = ({playerAlias, lastDescription, ii, aiCostUsd}) => {
  return <>
    <Ptext {...{fontSize: '5xl'}}>
      <AiCostLabel {...{aiCostUsd}} />
      {ii == 0 ? `${playerAlias}'s idea:` :  `${playerAlias} described:`}
    </Ptext>
    <Ptext {...{fontSize: '3xl'}}>{lastDescription}</Ptext>
  </>
}
const DrawingCard = ({playerAlias, lastFinishedTrails, lastImageDataUrl, lastIpfsCid, aiCostUsd}) => {
  const [finishedTrails, setFinishedTrails] = useState(lastFinishedTrails)
  const readonly = true
  const imageSrc = lastIpfsCid ? `/ipfs/${lastIpfsCid}.bin` : lastImageDataUrl
  return <>
    <Ptext {...{fontSize: '5xl'}}>
      <AiCostLabel {...{aiCostUsd}} />
      {playerAlias} drew:
    </Ptext>
    {imageSrc
      ? <Image {...{src: imageSrc, maxW: 600, maxH: 600, w: '100%'}} />
      : <CanvasGameDraw {...{finishedTrails, setFinishedTrails, readonly}} />}
  </>
}

const ResponseCard = ({playerAlias, lastDescription, lastFinishedTrails, lastImageDataUrl, lastIpfsCid, ii, aiCostUsd, ...props}) => {
  const hasDrawing = lastFinishedTrails || lastImageDataUrl || lastIpfsCid
  return <Box {...{textAlign: 'center', ...props}}>
    {lastDescription && <DescriptionCard {...{playerAlias, lastDescription, ii, aiCostUsd}} />}
    {hasDrawing && <DrawingCard {...{playerAlias, lastFinishedTrails, lastImageDataUrl, lastIpfsCid, aiCostUsd}} />}
  </Box>
}

const StackCard = ({stack}) => {
  return _.map(stack.responses, (response, ii) => <ResponseCard key={ii} {...{my: 10, ii, ...response}} />)
}

const OldGameInner = ({game_state}) => {
  const {query: {paper_stack_name}} = useRouter()

  const {hiddenState: {paperStacks}} = game_state

  if (paper_stack_name) {
    const stack = paperStacks[/** @type {string} */ (paper_stack_name)]
    if (!stack) return <Ptext fontSize="xl">Stack not found</Ptext>
    return <StackCard {...{stack, paper_stack_name}} />
  } else {
    return _.map(paperStacks, (stack, paper_stack_name) => {
      const response = stack.responses[0]
      if (!response) return null // glitched / incomplete game
      return <PromptCard key={paper_stack_name} {...{my: 10, paper_stack_name, ...response}} />
    })  
  }
}



export const OldGameBase = ({children}) => {
  const {query: {ppOldGameId, gameRoom}} = useRouter()

  const {data, loading, error} = useQueryNext(GetOldGameStateQuery, {variables: {ppOldGameId}, skip: !ppOldGameId})
  
  let {gqGameState: game_state, ...restH} = data?.gqGame || {}

  return <GamePgCont>
    <ErrLoadingWrap {...{error, loading, data}}>
      {!game_state ? (
        <Ptext fontSize="xl">Game not found</Ptext>
      ) : (
        <GameCtxWrap {...{value: {...game_state, ...restH}}}>
          <WrapRewindGame>
{children}
            <OldGameInner {...{game_state}} />
          </WrapRewindGame>
        </GameCtxWrap>
      )}
    </ErrLoadingWrap>
  </GamePgCont>
}